import type { SmartCardClientResponse } from './SmartCardClient';

// TRELP-7493: Redact `urlType` because it is considered UGC when retrieved via the iframely resolver
export const getSafeUrlType = (response: SmartCardClientResponse) => {
  if (response.meta.key === 'iframely-object-provider') {
    return 'REDACTED';
  }
  if (
    response.data &&
    'generator' in response.data &&
    typeof response.data.generator === 'object'
  ) {
    return response.data.generator.name;
  }
  return undefined;
};
